import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CourseState } from './course.reducer';

// Feature slice
export const selectCourseState = createFeatureSelector<CourseState>('course');

export const selectCourseId = createSelector(
  selectCourseState,
  state => state.courseType?.id || null
);
// Get Type
export const selectCourseType = createSelector(
  selectCourseState,
  state => state.courseType
);

// Get Content
export const selectCourseContent = createSelector(
  selectCourseState,
  state => state.courseContent
);

// Get Structure
export const selectCourseStructure = createSelector(
  selectCourseState,
  state => state.structure
);